import type { ServerProps } from '../../config/types.js'

export type UnpublishButtonClientProps = {}

export type UnpublishButtonServerPropsOnly = {} & ServerProps

export type UnpublishButtonServerProps = UnpublishButtonServerPropsOnly
